import BaseService from "src/packages/BaseService";

export default class BranchService extends BaseService {
	static get className() {
		return "branch";
	}
};
